import React, { useState, useEffect } from 'react'
import Layout from '../../../Components/Layout'
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import Breadcrumb from '../Component/Breadcrumb';
import Sidebar from '../../Dashboard/Component/Siderbar';
import { FaUser, FaPhone, FaEnvelope, FaLock, FaBirthdayCake, FaVenusMars, FaImage, FaPercentage } from 'react-icons/fa';
import config from '../../../config';

export default function Show() {
    const navigate = useNavigate();
    const { id } = useParams();
    const authUserData = JSON.parse(localStorage.getItem('user_data'));
    const [previewImage, setPreviewImage] = useState(null);
    const [userData, setUserData] = useState({
        name: "",
        surname: "",
        username: "",
        phone: "",
        email: "",
        profile_photo: null,
        markup: 0,
    });

    const fetchUserData = async (id) => {
        try {
            const url = `${config.API_BASE_URL_V1}agency/user/${id}/detail`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${authUserData.token}`,
                    "Content-Type": "application/json",
                },
                validateStatus: function (status) {
                    return status >= 200 && status < 300;
                },
            });

            if (response.data.status === 'success') {
                setUserData({
                    name: response.data.data.name || "",
                    surname: response.data.data.surname || "",
                    username: response.data.data.username || "",
                    phone: response.data.data.phone || "",
                    email: response.data.data.email || "",
                    profile_photo: response.data.data.profile_photo || null,
                    password: "*******",
                    markup: response.data.data.markup || 0,
                });
                if (response.data.data.profile_photo) {
                    setPreviewImage(response.data.data.profile_photo);
                }
            } else {
                Swal.fire({
                    title: "User not found",
                    icon: "error",
                    draggable: true,
                });
                navigate('/dashboard-users');
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
            Swal.fire({
                title: "Failed to fetch user",
                icon: "error",
                draggable: true,
            });
            navigate('/dashboard-users');
        }
    };

    useEffect(() => {
        if (id) {
            fetchUserData(id);
        }
    }, [id]);

    return (
        <Layout>
            <Breadcrumb title="User Details" />
            <div className="content">
                <div className="container">
                    <div className="row">
                        <Sidebar>
                            <div className="col-12">
                                <div className="card shadow-sm border-0 rounded-lg">
                                    <div className="card-header bg-primary py-3">
                                        <h5 className="fs-18 mb-0 text-white">User Information</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <div className="profile-image-container text-center">
                                                    <div className="profile-image-wrapper mb-3">
                                                        <img
                                                            src={previewImage || "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"}
                                                            alt="Profile"
                                                            className="rounded-circle profile-image"
                                                            onError={(e) => {
                                                                e.target.src = "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-8">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label d-flex align-items-center">
                                                            <FaUser className="me-2" />
                                                            Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={userData.name}
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label d-flex align-items-center">
                                                            <FaUser className="me-2" />
                                                            Surname
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={userData.surname}
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label d-flex align-items-center">
                                                            <FaUser className="me-2" />
                                                            Username
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={userData.username}
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label d-flex align-items-center">
                                                            <FaPhone className="me-2" />
                                                            Phone
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={userData.phone}
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label d-flex align-items-center">
                                                            <FaEnvelope className="me-2" />
                                                            Email
                                                        </label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            value={userData.email}
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label d-flex align-items-center">
                                                            <FaLock className="me-2" />
                                                            Password
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={userData.password}
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label d-flex align-items-center">
                                                            <FaPercentage className="me-2" />
                                                            Markup (%)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={userData.markup}
                                                            disabled
                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer bg-light py-3">
                                        <div className="d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-secondary px-4"
                                                onClick={() => navigate('/dashboard-users')}
                                            >
                                                Back to List
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <style jsx>{`
                                    .profile-image-container {
                                        padding: 20px;
                                        background: #f8f9fa;
                                        border-radius: 10px;
                                    }
                                    .profile-image-wrapper {
                                        width: 150px;
                                        height: 150px;
                                        margin: 0 auto;
                                        position: relative;
                                    }
                                    .profile-image {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        border: 3px solid #fff;
                                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                                    }
                                    .form-control:disabled {
                                        background-color: #f8f9fa;
                                        opacity: 1;
                                    }
                                    .card {
                                        transition: all 0.3s ease;
                                    }
                                    .card:hover {
                                        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
                                    }
                                `}</style>
                            </div>
                        </Sidebar>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
